import { QuoteMarkers } from "@atoms/QuoteMarkers";
import { TestimonialCard } from "@organisms/TestimonialCard";
import { quotesPosition } from "@/shared/quotesMarkers";
import { testimonialCards, testimonialSliderId } from "./variables";

export const TestimonialsSlider = () => {
  const TestimonialsSliderElement = document.createElement("div");
  TestimonialsSliderElement.className = "app-container relative";

  quotesPosition.forEach((position) => {
    TestimonialsSliderElement.appendChild(QuoteMarkers(position));
  });

  TestimonialsSliderElement.innerHTML += /* html */ `
        <div class="w-full overflow-hidden flex flex-col">
            <div class="flex flex-1 overflow-auto scrollbar-hide" id=${testimonialSliderId}></div>
        </div>
    `;

  const sliderElement = TestimonialsSliderElement.querySelector(
    `#${testimonialSliderId}`,
  );

  testimonialCards.forEach((card, index) => {
    if (sliderElement)
      sliderElement.appendChild(
        TestimonialCard({
          ...card,
          sliderId: testimonialSliderId,
          indexCard: index,
          lastIndexArray: testimonialCards.length - 1,
        }),
      );
  });

  return TestimonialsSliderElement;
};
